import { AnalyticsEvent } from '../models';

export class ErrorEvent implements AnalyticsEvent {
    name = 'ErrorEvent';

    constructor(public readonly errorType: string, public readonly errorName: string, public readonly action: string) {}
}